export const getFilteredClients = (clientsDetails) => {
  return clientsDetails.filter(({ IsActive, Deactivated }) => IsActive && !Deactivated);
};
